import { AREA_TITLE, ADOBE_TRACKING, TRACKING_EVENT_TYPE } from '@utilities/constants';

import useAdobeTracking from './use-adobe-tracking';

const usePreviewTracking = () => {
  const { trackEvent } = useAdobeTracking();
  const {
    CLICK_EVENT_GENERIC,
    PREVIEW_PAGE_IDENTIFIER,
    PREVIEW_ALERT_IMPRESSION,
    PREVIEW_UNSAVED_CHANGE_ALERT_IMPRESSION,
  } = ADOBE_TRACKING;

  const trackPreviewUnsavedSnackbarAlert = () => {
    trackEvent(
      CLICK_EVENT_GENERIC,
      PREVIEW_UNSAVED_CHANGE_ALERT_IMPRESSION,
      {
        area: AREA_TITLE,
        identifier: PREVIEW_PAGE_IDENTIFIER,
        targetLink: PREVIEW_ALERT_IMPRESSION,
      },
      TRACKING_EVENT_TYPE.IMPRESSION_EVENT,
    );
  };

  return {
    trackPreviewUnsavedSnackbarAlert,
  };
};

export default usePreviewTracking;
